import React from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';
import Tooltip from "@material-ui/core/Tooltip";

const ellipsisDefaultStyle = {
    overflow: 'hidden',
    overflowWrap: 'break-word',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-all',
};

/**
 * Base by react-ellipsis-with-tooltip @see https://github.com/amirfefer/react-ellipsis-with-tooltip
 *
 * MIT Licenced
 */
class EllipsisWithTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasOverflowingChildren: false,
            text: undefined,
        };
        this.updateOverflow = this.updateOverflow.bind(this);
    }

    updateOverflow(e) {
        const el = e.target;
        const {hasOverflowingChildren, text} = this.state;

        if (!hasOverflowingChildren && el.scrollWidth > el.clientWidth) {
            this.setState({hasOverflowingChildren: true});
            if (el.textContent !== text) {
                this.setState({text: el.textContent});
            }
        } else {
            this.setState({hasOverflowingChildren: false});
        }
    }

    render() {
        const {hasOverflowingChildren, text} = this.state;
        const {placement = 'bottom', style = {}, children, tooltipProps} = this.props;
        const ellipsisStyle = {...ellipsisDefaultStyle, ...style};

        return hasOverflowingChildren ? (
            <Tooltip
                id={`tooltip-${uuidV4()}`}
                placement={placement}
                title={text}
                {...tooltipProps}
            >
                <div style={ellipsisStyle}>{text || children}</div>
            </Tooltip>
        ) : (
            <div style={ellipsisStyle} onMouseEnter={this.updateOverflow}>
                {this.props.children}
            </div>
        );
    }
}

EllipsisWithTooltip.propTypes = {
    placement: PropTypes.string,
    style: PropTypes.object,
};

export default EllipsisWithTooltip;
